import { render, staticRenderFns } from "./LbsLogList.vue?vue&type=template&id=23bfb8dd&"
import script from "./LbsLogList.vue?vue&type=script&lang=js&"
export * from "./LbsLogList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports